import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchCart,
  addToCart,
  updateCartItem,
  removeFromCart,
  clearCart,
  createOrder,
  setCheckoutStep,
} from '../store/slices/cartSlice';
import Cookies from '../utils/cookies';

export const useCart = () => {
  const dispatch = useDispatch();
  const { cart, orders, currentOrder, pagination, isLoading, error, checkoutStep } = useSelector(
    (state) => state.cart
  );

  useEffect(() => {
    const token = Cookies.get('accessToken');
    if (token) {
      dispatch(fetchCart());
    }
  }, [dispatch]);

  const handleAddToCart = useCallback(
    (productId, quantity) => dispatch(addToCart({ productId, quantity })),
    [dispatch]
  );

  const handleUpdateCartItem = useCallback(
    (itemId, quantity) => dispatch(updateCartItem({ itemId, quantity })),
    [dispatch]
  );

  const handleRemoveFromCart = useCallback(
    (itemId) => dispatch(removeFromCart(itemId)),
    [dispatch]
  );

  const handleClearCart = useCallback(
    () => dispatch(clearCart()),
    [dispatch]
  );

  const handleCreateOrder = useCallback(
    (orderData) => dispatch(createOrder(orderData)),
    [dispatch]
  );

  const setStep = useCallback(
    (step) => dispatch(setCheckoutStep(step)),
    [dispatch]
  );

  const getItemQuantity = useCallback(
    (productId) => {
      const items = cart?.items || [];
      const item = items.find((i) => i.productId === productId);
      return item ? item.quantity : 0;
    },
    [cart?.items]
  );

  return {
    cart,
    orders,
    currentOrder,
    pagination,
    isLoading,
    error,
    checkoutStep,
    addToCart: handleAddToCart,
    updateCartItem: handleUpdateCartItem,
    removeFromCart: handleRemoveFromCart,
    clearCart: handleClearCart,
    createOrder: handleCreateOrder,
    setCheckoutStep: setStep,
    getItemQuantity,
    cartItemCount: cart?.itemCount || 0,
    cartTotal: cart?.total || 0,
  };
};
